var map = {
	"./0-interior-roof.svg": "5bc2",
	"./1-attic-floor.svg": "24cb",
	"./2-exterior-wall.svg": "f72a",
	"./3-windows.svg": "ffe8",
	"./4-gaz-boiler.svg": "70e3",
	"./5-heat-pump.svg": "6498",
	"./6-ventilation.svg": "e7f1",
	"./7-wall-cavity.svg": "c6cf",
	"./8-solar-panel.svg": "1ff0",
	"./9-exterior-roof.svg": "cd06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af57";